<template>
  <div class="restaurant-actions">
    <v-btn
      small
      color="primary"
      text
      class="mx-2"
      :to="{ name: 'restoran-id-korisnici', params: { id: item.id } }"
    >
      {{ $t("users") }} {{ item.users_count }}
    </v-btn>
    <edit-button class="mr-2" @click="$emit('edit', item)" />
    <remove-button @click="$emit('delete', item)" />
  </div>
</template>

<script>
export default {
  name: "RestaurantActions",
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  emits: ["edit", "delete"],
};
</script>

<style scoped>
.restaurant-actions {
  display: flex;
  align-items: center;
}
</style>
